<template>
  <!-- time tips -->
  <div class="tip-msg">
    <p>
      <span style="color:#4CAF50;"><b>{{$t("main['支付提示']")}}</b></span>:&nbsp;
      {{$t("main['请在']")}}<span style="color:red;">
        <font v-if="orderInfo.timePayLenSc">{{orderInfo.timePayLenSc}}</font>
        <font v-else>X</font>
      </span>{{$t("main['秒内']")}}{{$t("main['完成']")}}<span style="color:#4CAF50;">{{$t("main['支付']")}}</span>,
      {{$t("main['超时会自动']")}}<span style="color:red;">{{$t("main['取消']")}}</span>
    </p>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
